import ErrorRobot from '@anm/components/errors/ErrorRobot';
import { FC, useEffect } from 'react';
import { LiveStream } from 'types/stream';
import * as semrush from '@anm/helpers/semrush';
import { LoaderWrapper } from '../../../components/hosting/CustomizationSection';
import { WEBINAR_TABS } from '../../../pages/webinar';
import Layout from '../Layout';
import WebinarHeader from '../WebinarHeader';
import WebinarPreview from '../WebinarPreview';

import useFetchWebinarData from './hooks/useFetchWebinarData';
import useVideoSizes from './hooks/useVideoSizes';
import { WebinarSectionWrapper } from './styles';
import routes from '../../../routes';
import useFetchWebinar from './hooks/useFetchStream';
import useFetchDomains from '../DomainsTab/hooks/useFetchDomains';

type WebinarSectionProps = {
  stream: LiveStream;
  webinarId: string;
  activeButton: WEBINAR_TABS;
  onActiveButtonChange: (tab: WEBINAR_TABS) => void;
};

const WebinarSection: FC<WebinarSectionProps> = ({ stream, ...otherProps }) => {
  const sizes = useVideoSizes(stream);
  const title = stream.meta.title;

  useFetchWebinar();
  useFetchDomains();

  return (
    <>
      {!semrush.isSemrushIframe() && <WebinarHeader webinarId={otherProps.webinarId} />}
      <WebinarSectionWrapper>
        <Layout {...{ sizes, stream, title, ...otherProps }} rooomId={stream.meta.roomId} />
        <WebinarPreview {...{ sizes, title, ...otherProps }} />
      </WebinarSectionWrapper>
    </>
  );
};

export const SectionWrapper: FC<Omit<WebinarSectionProps, 'stream'>> = props => {
  const [stream, error, isPending, canRender] = useFetchWebinarData(props.webinarId);
  const isDeleted = stream?.state === 'DELETED';

  useEffect(() => {
    isDeleted && routes.Router.pushRoute('/404', {}, { shallow: true });
  }, [isDeleted]);

  if (isDeleted) return null;

  switch (true) {
    case canRender:
      return <WebinarSection {...props} stream={stream!} />;
    case !!error:
      return <ErrorRobot title={error?.message} backgroundVariant="blue-light" />;
    case isPending:
      return <LoaderWrapper size="large" color="blue" />;
    default:
      return null;
  }
};

export default SectionWrapper;
